// ./src/lib/FramesList.js

import FrameModel from './FrameModel';

// export const GameNotFound = new FrameModel({
//   frame_type: 'text_message',
//   message: 'Игра не найдена',
//   modifier: 'dark',
// });

export const GameNotFound = new FrameModel({
  frame_type: 'game_not_found',
});

export const PincodeRequest = new FrameModel({
  frame_type: 'enter_pincode',
});

export const Authenticate = new FrameModel({
  frame_type: 'auth_login',
});

export const GameIsLoading = new FrameModel({
  frame_type: 'loading',
});

export const PleaseWait = new FrameModel({
  frame_type: 'text_message',
  message: 'Скоро начнется игра',
});

export const TeamSignIn = new FrameModel({
  frame_type: 'team_sign_in',
});

export const TeamSignInNoCity = new FrameModel({
  frame_type: 'team_sign_in',
  meta: {
    no_city: true,
  },
});
